<template>
  <modal v-show="contactUsModalOpen" @close="$store.commit('ui/contactUsModalOpen', false)" class="contactus-modal">
    <div class="content row justify-content-between" slot="body">
      <div class="col-md-5">
        <h2 class="modal-register-header" slot="header">{{ $t('home_contact_us')}}</h2>
        <p>{{ $t('home_contact_us_content') }}</p>
      </div>
      <div class="col-md-6">
        <form @submit.prevent="contactUs">

          <div class="form-row">
            <div class="form-group col">
              <label for="contact-first-name">{{ $t('home_contact_us_first_name') }}</label>
              <input type="text" class="form-control" id="contact-first-name" v-model="firstName" :placeholder="$t('home_contact_us_first_name')">
            </div>
            <div class="form-group col">
              <label for="contact-last-name">{{ $t('home_contact_us_last_name') }}</label>
              <input type="text" class="form-control" id="contact-last-name" v-model="lastName" :placeholder="$t('home_contact_us_last_name')">
            </div>
          </div>
          <div class="form-group">
            <label for="contact-email">{{ $t('home_contact_us_email') }}</label>
            <input type="email" class="form-control" id="contact-email" v-model="email" :placeholder="$t('home_contact_us_email')">
          </div>
          <div class="form-group">
            <label for="contact-message">{{ $t('home_contact_us_message') }}</label>
            <textarea name="message" class="form-control" id="contact-message" v-model="message" rows="4" :placeholder="$t('home_contact_us_message')"></textarea>
          </div>

          <p class="help-text text-danger" v-if="invalidCredentials">{{ $t('login_forgot_invalid') }}</p>

          <button type="submit" class="btn btn-primary btn-block">{{ $t('home_contact_us_submit') }}</button>
        </form>
      </div>

    </div>
    <div class="content row" slot="body">
        <div class="col">

        </div>
    </div>
    <div slot="footer">
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal';

export default {
  name: "ModalContactUs",
  components: { Modal },
  data() {
    return {
      invalidCredentials: false,

      firstName: "",
      lastName: "",
      email: "",
      message: "",

      allFields: ["firstName", "lastName", "email", "message"] //silly helper
    }
  },
  methods: {
    showFeedback ({suggestions, warning}) {
      this.suggestions = suggestions;
      this.warning = warning;
    },
    validate() {
      if(!this.allFieldsFilled) {
        this.$snotify.error( this.$t('validate_all_fields_required') );
        return false;
      }
    },
    contactUs(e) {
      if(this.validate() == false) return;

      this.$store.dispatch('auth/contactUs', {
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email,
        message: this.message
      })
              .then(data => {
                this.$store.commit('ui/contactUsModalOpen', false);
                this.$snotify.success( this.$t('home_contact_us_successfully') );
              })
              .catch(err => {
                  this.$snotify.error( this.$t('home_contact_us_error') );
              })
    }
  },
  computed: {
    disableSubmit() {
      return !this.allFieldsFilled;
    },
    contactUsModalOpen() {
      return this.$store.state.ui.contactUsModalOpen;
    }
  }
}
</script>
